<template>
  <ul class="list02-list">
    <li :class="{'list02-item': model.id != 0, 'is-parent': group1.isFolder, 'is-open': group1.isFolder && group1.isOpen}">
      <div v-if="model.id != 0 && !group1.hasFormatList" class="wrap">
        <div class="label">
          <span class="main">{{ model.title }}</span>
        </div>
      </div>
      <ul v-if="model.id != 0 && group1.hasFormatList">
        <li class="list02-item">

          <div class="wrap download">
            <div class="label">
              <ul>
                <li v-for="(formatItem, index) in group1.formatList" :key="'format_' + index" :class="{'keyword': formatItem.keyword_exists === 1}">
                  <a :href="formatItem.url" class="main ga-document-downloads-list-download-format">
                    <FontawesomeIcon class="icn-download ga-document-downloads-list-download-format" icon="arrow-to-bottom" /><span v-html="formatItem.format_name" class="ga-document-downloads-list-download-format"></span>
                  </a>
                </li>
              </ul>
              <!-- タイトル1行目 -->
              <a @click.prevent.stop="group1.onClickQATitleOfList(model.id)" class="link-sup" role="button" v-html="model.title_first_line"></a>
              <!-- タイトル2行目以降 -->
              <template v-for="(line, index) in model.title_after_second_lines">
                <span :key="'second_line_' + index" class="indent" v-html="line"></span>
              </template>
            </div>
          </div>

        </li>
      </ul>
      <template v-show="group1.isOpen" v-if="group1.isFolder">
        <PCDocumentDownloadsTreeItem
          v-for="model2 in group1.children" :model="model2" :key="model2.node_id"
          :matchedStartNo="group1.matchedStartNo"
          :matchedEndNo="group1.matchedEndNo"
          :matchedTotal="group1.matchedTotal"
        />
      </template>
    </li>
  </ul>
</template>

<script>
// 書式DL一覧画面：書籍目次ツリー生成用コンポーネント
import { ref, reactive, computed, watch, defineComponent, onMounted } from '@vue/composition-api'
import PCDocumentDownloadsTreeItem from '@/components/pc/partial/qa/PCDocumentDownloadsTreeItem'
import * as logicDocumentDownloadsTreeItem from '@/logic/qa/DocumentDownloadsTreeItem'

export default defineComponent({
  name: 'PCDocumentDownloadsTreeItem',
  components: {
    PCDocumentDownloadsTreeItem
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    matchedStartNo: {
      type: Number,
      required: true
    },
    matchedEndNo: {
      type: Number,
      required: true
    },
    matchedTotal: {
      type: Number,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      group1.init()
    })

    const group1 = logicDocumentDownloadsTreeItem.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
  .main { 
    // マッチしたキーワードのハイライト表示
    ::v-deep em {
      background-color: $color-yellow;
    }
  }
  // おかしな位置に中点が表示されてしまう問題の対応
  .list02 .wrap.download .label ul li:before {
    display: none
  }
</style>
